import { render, staticRenderFns } from "./cleaning-setting.vue?vue&type=template&id=9d7ce162&"
import script from "./cleaning-setting.vue?vue&type=script&lang=js&"
export * from "./cleaning-setting.vue?vue&type=script&lang=js&"
import style0 from "./cleaning-setting.vue?vue&type=style&index=0&id=9d7ce162&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports